import calculation from './calculation'
// 转换年月日时分秒
function formatFullTime(timestamp){
    var date = new Date(timestamp);
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1):date.getMonth()+1) + '-';
    var D = (date.getDate()< 10 ? '0'+date.getDate():date.getDate())+ ' ';
    var h = (date.getHours() < 10 ? '0'+date.getHours():date.getHours())+ ':';
    var m = (date.getMinutes() < 10 ? '0'+date.getMinutes():date.getMinutes()) + ':';
    var s = date.getSeconds() < 10 ? '0'+date.getSeconds():date.getSeconds();
    return Y+M+D+h+m+s;
}
// 转换年月日
function formatFullDate(timestamp){
    if(!timestamp){
        return ''
    }
    var date = new Date(timestamp);
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1):date.getMonth()+1) + '-';
    var D = (date.getDate()< 10 ? '0'+date.getDate():date.getDate());
    return Y+M+D;
}
// 转换时分秒
function formatTime(timestamp){
    if(!timestamp){
        return ''
    }
    var date = new Date(timestamp);
    var h = (date.getHours() < 10 ? '0'+date.getHours():date.getHours())+ ':';
    var m = (date.getMinutes() < 10 ? '0'+date.getMinutes():date.getMinutes()) + ':';
    var s = date.getSeconds() < 10 ? '0'+date.getSeconds():date.getSeconds();
    return h+m+s;
}

/**
  * 转换年月日时分秒
  */
function customFormatFullTime(timestamp,format='YYYY-MM-DD h:m:s'){
    var date = new Date(timestamp);
    var Y = date.getFullYear();
    var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1):date.getMonth()+1);
    var D = (date.getDate()< 10 ? '0'+date.getDate():date.getDate());
    var h = (date.getHours() < 10 ? '0'+date.getHours():date.getHours());
    var m = (date.getMinutes() < 10 ? '0'+date.getMinutes():date.getMinutes());
    var s = date.getSeconds() < 10 ? '0'+date.getSeconds():date.getSeconds();
    return format.replace('YYYY',Y).replace('MM',M).replace('DD',D).replace('h',h).replace('m',m).replace('s',s)
}
function toInteger(n){
    return Math.abs(parseInt(n))
}
function toDecimal(n,zero_num=2){
    let value = '1'
    for(let i =0;i<zero_num;i++){
        value+='0'
    }
    value = parseInt(value)
    return calculation.accDiv(parseInt(calculation.accMul(parseFloat(n),value)),value)
}
function toXls(content){
    const blob = new Blob([content])
    if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a')
        const fileNamex = `${Date.now()}.xls`
        elink.download = fileNamex
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink)
    } else { // IE10+下载
        navigator.msSaveBlob(blob, fileNamex)
    }
}
function dateAddDays(dateStr,dayCount){
    var tempDate=new Date(dateStr);//把日期字符串转换成日期格式
    var resultDate=new Date((tempDate/1000+(86400*dayCount))*1000);//增加n天后的日期
    
    return formatFullDate(resultDate);
}
/**
 * 手机号是否可用
 * @param {int}} $poneInput 
 * @returns 
 */
function isPoneAvailable($poneInput) {
    var myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (!myreg.test($poneInput)) {
        return false;
    } else {
        return true;
    }
}
/**
 * 重构部门列表
 * @param {*} list 
 * @returns 
 */
 function reconsitutionDepartmentList(data){
    return [
        {
            department_id:0,
            department_name:data.company.name,
            id:0,
            children:data.list?data.list:[]
        }
    ]
}
/**
 * 如果time2大于time1 返回true 否则 返回false
 * @param {*} time1 
 * @param {*} time2 
 * @returns 
 */
function compareTime(time1,time2) {
    if(time_to_sec(time2)-time_to_sec(time1)>0){ 
        return true;
    }
    return false;
}

//将时分秒转为时间戳
function time_to_sec(time) {
    if (time !== null) {
        var s = "";
        var hour = time.split(":")[0];
        var min = time.split(":")[1];
        var sec = time.split(":")[2];
        s = Number(hour * 3600) + Number(min * 60) + Number(sec);
        return s;
    }
}

export {
    formatFullTime,
    formatFullDate,
    formatTime,
    toInteger,
    toDecimal,
    toXls,
    dateAddDays,
    isPoneAvailable,
    reconsitutionDepartmentList,
    customFormatFullTime,
    compareTime
}